export const getValueFromPixelString = (stringPixel) => {
    return parseFloat(stringPixel);
};
//# sourceMappingURL=TokenHelpers.js.map